'use client';

import React from 'react';
import { ShoppingCart as ShoppingCartIcon } from 'lucide-react';
import Link from 'next/link';

import { IconWithBadge } from '@nutralab/ui';

import { useCart } from '@/app/_providers/CartProvider';

interface CartNavIconProps {
    label: string;
}

const MAX_COUNT_VALUE = 99;

/** The cart item of the navbar with the number of items. */
export function CartNavIcon({ label }: CartNavIconProps): React.ReactElement {
    const { items } = useCart();
    const count = Array.from(items.values()).reduce((sum, i) => sum + i.quantity, 0);

    return (
        <IconWithBadge icon={<ShoppingCartIcon />} label={label} count={count} maxCountValue={MAX_COUNT_VALUE} asChild>
            <Link href="/cart" />
        </IconWithBadge>
    );
}
